import { render } from "./PresentationMultiPageForm.vue?vue&type=template&id=223427be&scoped=true&ts=true"
import script from "./PresentationMultiPageForm.vue?vue&type=script&lang=ts"
export * from "./PresentationMultiPageForm.vue?vue&type=script&lang=ts"

import "./PresentationMultiPageForm.vue?vue&type=style&index=0&id=223427be&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-223427be"]])

export default __exports__